import {
  KeyboardArrowDown,
  MoreHoriz,
  Search,
  CheckCircle,
  CheckCircleOutline,
} from "@material-ui/icons";
import React from "react";
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PhoneNumber from "../Common/phoneNumber";
import {
  getUserRolesAction,
  removeUsersAction,
  vendorUserAction,
  forgotPasswordAction,
  reActivateDeletedUserAction,
  searchUserAction,
  artistsVendorUserAction,
} from "./../../actions/UserActions";
import noRecord from "./../../assets/img/no-record.png";
import DeletePrompt from "../Common/DeletePrompt";
import { toastMessage } from "../Common/Common";
import * as code from "./../../config/Constants";

var _ = require("lodash");
class Vendor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showArchieve: false,
      show: false,
      showDelete: "Artists",
      showLoader: true,
      searchParam: "",
      modalUserData: {},
      modalCmpnyData: {},
      vendorUsers: [],
      searchedVendors: [],
      vendorTypeFilter: [],
      filteredvendorUsers: [],
      deletePrompt: false,
      userId: "",
      vendorType: null,
      masterContingency: [
        "HOME INSPECTOR",
        "SEPTIC INSPECTOR",
        "WOOD INSPECTOR",
        "RADON INSPECTOR",
        "LISTING AGENT",
        "CLOSING AGENT",
        "FINANCING",
        "WATER TEST INSPECTOR",
        "WELL TEST INSPECTOR",
      ],
      selectedRole: "",
      recordPerPage: code.RECORD_PER_PAGE,
      page: 0,
    };
    this.removeVendorById = this.removeVendorById.bind(this);
    this.selectVendorTypeChange = this.selectVendorTypeChange.bind(this);
  }

  columns = [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      ignoreRowClick: true,
      width: "25%",
    },
    {
      name: "Artworks",
      selector: "transactions",
      sortable: true,
      width: "10%",
      center: true,
      ignoreRowClick: true,
    },
    {
      name: "Phone Number",
      selector: "mobile",
      width: "10%",
      //sortable: true,
    },
    {
      name: "Email",
      selector: "email",
      sortable: true,
      width: "25%",
    },
    {
      name: "Registered Status",
      selector: "registeredStatus",
      //sortable: true,
      width: "15%",
    },
    {
      name: "",
      selector: "active",
      sortable: true,
      width: "10%",
      ignoreRowClick: true,
    },
    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "5%",
    },
  ];

  getVendorsList(pageIndex) {
    this.props
      .artistsVendorUserAction(this.state.recordPerPage, pageIndex)
      .then((res) => {
        // console.log('getVendorsList res ==> ',res);
        // console.log('getVendorsList this.props.vendorUsers ==> ',this.props.vendorUsers);
        this.props.getUserRolesAction();
        this.setState({
          vendorUsers: this.props.vendorUsers || [],
          filteredvendorUsers: this.props.vendorUsers || [],
          showLoader: false,
        });
      })
      .catch((err) => {});
  }
  changePage = async (page) => {
    if (this.state.isSearched) {
      this.searchVendor(this.state.searchParam, page - 1);
    } else {
      this.getVendorsList(page - 1);
    }
  };
  componentWillMount() {
    this.getVendorsList(this.state.page);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
    this.setState({ showLoader: false });
  }

  removeVendorById(uId) {
    this.setState({ showLoader: true, deletePrompt: false });
    this.props.removeUsersAction(uId).then((res) => {
      if (this.props.status) {
        this.setState({ showLoader: false, searchParam: "", selectedRole: "" });
        this.getVendorsList(this.state.page);
      }
    });
  }
  /** Filter for vendor type dropdown */
  selectVendorTypeChange(e) {
    var vendors = [];
    this.setState({ vendorType: e });
    if (e.target.value !== "" && e.target.value !== "other") {
      vendors = this.state.filteredvendorUsers.filter((o) => {
        var found = false;
        Object.keys(o).forEach((v) => {
          if (v == "contactRole") {
            if (
              o[v].find(
                (userType) =>
                  userType == e.target.options[e.target.selectedIndex].text
              ) !== undefined
            ) {
              found = true;
            }
          }
        });
        return found;
      });
    } else if (e.target.value !== "" && e.target.value === "other") {
      vendors = this.state.filteredvendorUsers.filter((o) => {
        var found = false;
        Object.keys(o).forEach((v) => {
          if (v == "contactRole") {
            if (
              !o[v].every((userType) =>
                this.state.masterContingency.includes(userType)
              )
            ) {
              found = true;
            }
          }
        });
        return found;
      });
    } else {
      vendors = this.state.filteredvendorUsers;
    }
    this.setState({
      vendorUsers: vendors,
      vendorTypeFilter: vendors,
      selectedRole: e.target.value,
    });
  }

  openDeletePrompt(id) {
    this.setState({
      deletePrompt: true,
      userId: id,
    });
  }
  /**
   * @desc search and filter vendor list
   * @param {*} param
   */
  searchVendor(param, page = this.state.page) {
    // this.props
    //   .searchUserAction("vendor", param.trim(), this.state.recordPerPage, page)
    //   .then((response) => {
    //     console.log('searchVendor response==>',response);
    //     console.log('searchVendor response.data.data==>',response.data.data);
    //     this.setState({
    //       vendorUsers: response.data.data,
    //       searchedTransactions: response.data.data,
    //       showLoader: false,
    //     });
    //   })
    //   .catch((err) => {});

    this.props
      .artistsVendorUserAction(this.state.recordPerPage, page, param.trim())
      .then((res) => {
        // console.log('getVendorsList res ==> ',res);
        // console.log('getVendorsList this.props.vendorUsers ==> ',this.props.vendorUsers);
        this.props.getUserRolesAction();
        this.setState({
          vendorUsers: this.props.vendorUsers || [],
          filteredvendorUsers: this.props.vendorUsers || [],
          showLoader: false,
        });
      })
      .catch((err) => {});
  }
  getSearchResult = _.debounce((param) => {
    this.setState({ showLoader: true });
    this.searchVendor(param);
  }, 1000);
  search(param) {
    this.getSearchResult(param);
    this.setState({
      searchParam: param,
      isSearched: param.trim() == "" ? false : true,
    });
  }

  goToTransaction(t) {
    // console.log("+++=================t========", t);
    let data = { callfromflg: "Vendor", id: t };
    localStorage.setItem("transactions", JSON.stringify(data));
    this.props.history.push({
      pathname: "/artwork",
      // transactions: t,
    });
  }

  requestResetPassword(email) {
    let data = { email: email.toLowerCase() };
    this.props.forgotPasswordAction(data).then((res) => {
      if (res.status === code.OK) {
        toastMessage(code.SUCCESS, "Password reset link sent.");

        this.setState({
          forgotSuccess: true,
        });
      }
    });
  }

  reActivateUser(userId) {
    this.props
      .reActivateDeletedUserAction(userId)
      .then((response) => {
        this.getVendorsList(this.state.page);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    let rows = [];
    let vendors = this.state.vendorUsers || [];
    // console.log('render vendors ===>',vendors);
    for (var i = 0, len = vendors.length; i < len; i++) {
      let user = vendors[i];

      let data = {
        id: user._id,
        name:
          user.authId && user.authId !== "" ? (
            <Link to={"/UserProfile/" + user._id} className="p-0">
              {user.firstname + " " + user.lastname}
            </Link>
          ) : (
            user.firstname + " " + user.lastname
          ),
        transactions: user.transactionCount ? (
          user.transactionCount > 0 ? (
            <Button
              variant="link"
              className="p-0"
              onClick={() => this.goToTransaction(user._id)}
            >
              {" "}
              {user.transactionCount}
            </Button>
          ) : (
            // user.transactions.length
            "0"
          )
        ) : (
          "0"
        ),
        mobile: <PhoneNumber phoneNumber={user.mobileNumber} />,
        email: <div className="email-case">{user.email.address}</div>,
        registeredStatus:
          user.authId && user.authId !== "" ? (
            <CheckCircle className="check" style={{ color: "green" }} />
          ) : (
            <CheckCircleOutline className="check-out" />
          ),
        active: (
          <Button
            variant="primary"
            className={"btn-blue btn-grid "}
            disabled={!user.isDeleted}
            onClick={() => this.reActivateUser(user._id)}
          >
            Activate
          </Button>
        ),
        role: user.contactRole,
        action:
          !user.isDeleted && (user.authId && user.authId !== "") ? (
            <Dropdown alignRight className="dropdown-action">
              <Dropdown.Toggle
                variant="transparent"
                id="dropdown-folder1"
                className="p-0"
              >
                <MoreHoriz />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  className="color-dark-orange-3 font-14"
                  href="javascript:void(0)"
                  onClick={() => {
                    this.openDeletePrompt(user._id);
                  }}
                >
                  Remove
                </Dropdown.Item>
                <Dropdown.Item
                  className="color-dark-orange-3 font-14"
                  href="javascript:void(0)"
                  onClick={() => {
                    this.requestResetPassword(user.email.address);
                  }}
                >
                  {" "}
                  Reset Password
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : null,
      };

      rows.push(data);
    }

    const filteredContacts = rows.filter((contact) =>
      contact.role.includes("Artist")
    );

    //console.log('filteredContacts ===> ',filteredContacts);

    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col className="col-auto">
            <h4 className="title-med mt-0 pt-1">{this.state.showDelete}</h4>
          </Col>
          <Col align="right">
            <div className="icon-wrapper ml-2" style={{ width: "40%" }}>
              <Form.Control
                type="text"
                className="form-control-head"
                placeholder="Search"
                value={this.state.searchParam}
                onChange={(e) => {
                  this.search(e.target.value);
                }}
              />
              <span className="form-control-icn">
                <Search />
              </span>
            </div>
          </Col>
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={filteredContacts}
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Artists Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              pagination={true}
              paginationServer={true}
              paginationTotalRows={this.props.totalVendors}
              paginationPerPage={this.state.recordPerPage}
              onChangePage={(page) => this.changePage(page)}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
            />

            <DeletePrompt
              deletePrompt={this.state.deletePrompt}
              itemId={this.state.userId}
              cancel={() => {
                this.setState({ deletePrompt: false });
              }}
              deleteConfirm={this.removeVendorById}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vendorUsers: state.reducer.vendorUsers,
    totalVendors: state.reducer.totalVendors,
    roles: state.reducer.roles,
    status: state.reducer.status,
    forgotsuccess: state.reducer.forgotsuccess,
  };
};

export default connect(
  mapStateToProps,
  {
    vendorUserAction,
    getUserRolesAction,
    removeUsersAction,
    forgotPasswordAction,
    reActivateDeletedUserAction,
    searchUserAction,
    artistsVendorUserAction,
  }
)(Vendor);
